function hasSomeParentTheClass(element, className) {
    if (element.className && element.className.split(' ').indexOf(className) >= 0) {
        return true;
    }
    return element.parentNode && hasSomeParentTheClass(element.parentNode, className);
}

const directive = {
    bind(el, binding) {
        let pos = {top: 0, left: 0, x: 0, y: 0};

        const mouseDownHandler = function (e) {
            if (hasSomeParentTheClass(e.target, binding.value)) {
                return;
            }

            el.style.userSelect = 'none';

            pos = {
                left: el.scrollLeft,
                top: el.scrollTop,
                // Get the current mouse position
                x: e.clientX,
                y: e.clientY,
            };

            document.addEventListener('mousemove', mouseMoveHandler);
            document.addEventListener('mouseup', mouseUpHandler);
        };

        const mouseMoveHandler = function (e) {
            // How far the mouse has been moved
            const dx = e.clientX - pos.x;
            const dy = e.clientY - pos.y;

            // Scroll the element

            el.scrollTop = pos.top - dy;
            el.scrollLeft = pos.left - dx;
        };

        const mouseUpHandler = function (e) {
            el.style.removeProperty('user-select');
            if (e.target.className === 'plan__item') {
                return;
            }

            document.removeEventListener('mousemove', mouseMoveHandler);
            document.removeEventListener('mouseup', mouseUpHandler);
        };

        // Attach the handler
        el.addEventListener('mousedown', mouseDownHandler);
    }
};

const DragScroll = {
    install(Vue) {
        Vue.directive('dragscroll', directive);
    }
};

export default DragScroll;